import React from 'react';

const Vue_v_pre = () => {
  return (
    <div>
      <h1>Vue_v_pre Component</h1>
      <p>This is the Vue_v_pre tutorial page.</p>
    </div>
  );
}

export default Vue_v_pre;
